import { render, staticRenderFns } from "./CourseWiseEvaluation.vue?vue&type=template&id=2c0f8bcb&"
import script from "./CourseWiseEvaluation.vue?vue&type=script&lang=js&"
export * from "./CourseWiseEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports